<template>
  <div v-if="user.match('enco')">
    <vs-select
      class="selectExample"
      label="Dashboard Select"
      v-model="select1"
      @change="dashboardChange()"
    >
      <vs-select-item
        :key="index"
        :value="item"
        :text="item"
        v-for="(item, index) in encoDashboardlist"
      />
    </vs-select>
  </div>
  <div v-else>
    <vs-select class="selectExample" label="Dashboard Select" v-model="select1">
      <vs-select-item
        :key="index"
        :value="item.link"
        :text="item.name"
        v-for="(item, index) in dashboardlist"
      /> </vs-select
    ><br />
    <iframe
      :src="select1"
      name="iframe_a"
      :height="height"
      width="100%"
      title="Iframe Example"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "Dashboard",
  data: () => ({
    user: "",
    admin: "",
    dashboardlist: [],
    encoDashboardlist: [],
    select1: "",
    height: 0,
    token: "",
  }),
  watch: {
    select1() {
      console.log(this.select1)
      if(this.select1 == 'Workforce') this.$router.push({path: "/resource-dashboard"})
    }
  },
  methods: {
    dashboardChange() {
      if (this.select1 == "Department A")
        this.$router.push({
          path: "departmentA",
        });
      if (this.select1 == "Department B")
        this.$router.push({
          path: "departmentB",
        });
    },
  },
  async mounted() {
    this.user = this.$session.get("username");
    this.admin = this.$session.get("admin");
    this.token = this.$session.get("token");
    try {
      this.dashboardlist = await this.$API.get("dashboardlist/user")
      this.dashboardlist = this.dashboardlist.data[0].list
    } catch (error) {
      console.log(error)
    }
    if(this.user == 'swiftdemo') this.dashboardlist.push({name:'Workforce Management', link:'Workforce'})
    this.height = window.innerHeight;
    if (this.user.match("enco")) {
      this.encoDashboardlist = ["Department A", "Department B"];
    }
    if (this.user == "birchteladmin" || this.admin == "birchteladmin")
      this.$router.push({ name: "sriboonrueng" });
    if (this.user == "smarthome") this.$router.push({ name: "Smarthome" });
  },
};
</script>

<style>
</style>